








































































import {
    computed,
    defineComponent,
    onMounted,
    PropType,
    reactive,
    ref,
    toRefs,
    watch,
} from '@vue/composition-api';
import { VContainer, VRow, VCol, VSwitch, VSelect } from 'vuetify/lib';
import {
    ITrainingPlanUnitStandard,
    IVersionDto,
    UnitStandardVersionClientInstance,
} from '@/api';
import CnDateField from '../Cn-DateField.vue';
export default defineComponent({
    name: 'ResultRow',
    components: {
        VContainer,
        VRow,
        VCol,
        VSwitch,
        VSelect,
        CnDateField,
    },
    props: {
        item: {
            type: Object as PropType<ITrainingPlanUnitStandard>,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        rccAssessmentAllowed: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['date-achieved', 'is-rcc', 'version-changed'],
    setup(props, context) {
        // #region hooks
        // #endregion

        // #region data
        const versions = ref<IVersionDto[]>([]);
        const versionsLoading = ref(false);
        const selectedVersionId = ref<string | null>(null);

        const state = reactive({
            dateAchieved: computed({
                get: () => props.item.dateAchieved,
                set: (value) => {
                    context.emit('date-achieved', value);
                },
            }),
            isRcc: computed({
                get: () => props.item.isRcc == true,
                set: (value) => {
                    context.emit('is-rcc', value);
                },
            }),
            itemVersion: computed(() => props.item.version),
        });
        // #endregion

        // #region methods
        const getLatestVersion = (): IVersionDto | null => {
            if (versions.value.length === 0) {
                return null;
            }

            return versions.value.reduce((latest, current) => {
                const latestVersion =
                    latest.version ?? Number.NEGATIVE_INFINITY;
                const currentVersion =
                    current.version ?? Number.NEGATIVE_INFINITY;

                return currentVersion > latestVersion ? current : latest;
            });
        };

        // #endregion

        watch(selectedVersionId, (value: string | null) => {
            const ver = versions.value.find((v) => v.unitStandardId === value);
            context.emit('version-changed', {
                unitStandardId: value,
                version: ver?.version,
            });
        });

        // #region lifeCycle
        onMounted(async () => {
            const unitStandardCode = props.item.unitStandardCode;

            if (
                !props.readonly &&
                !props.item.isExistingResult &&
                unitStandardCode
            ) {
                versionsLoading.value = true;
                try {
                    const result = await UnitStandardVersionClientInstance.get(
                        unitStandardCode,
                    );
                    if (result?.result?.versions) {
                        versions.value = result.result.versions;
                        const linkedVersion = versions.value.find(
                            (v) =>
                                v.unitStandardId === props.item.unitStandardId,
                        );
                        const defaultVersion =
                            linkedVersion ?? getLatestVersion();

                        if (defaultVersion) {
                            selectedVersionId.value =
                                defaultVersion.unitStandardId ?? null;
                        }
                    }
                } finally {
                    versionsLoading.value = false;
                }
            }
        });
        // #endregion

        return {
            ...toRefs(state),
            selectedVersionId,
            versions,
            versionsLoading,
        };
    },
});
